
<template>
  <div id="history" class="main">
    <Hero backimg="background-image:url(/images/hero-history.jpg)"
      :title="$t('about.history.banner')"
      sub="" />

    <div class="color-change">
      <AboutMenu />

      <Swipe1 />

      <Historylist />
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'
import AboutMenu from '@/components/AboutMenu.vue'
import Swipe1 from '@/components/Swipe1.vue'
import Historylist from '@/components/Historylist.vue'

export default {
  components: {
    Hero,
    AboutMenu,
    Swipe1,
    Historylist
  },

  mounted () {
    document.title = `${this.$t('nav.about')}-${this.$t('title')}`
    this.$nextTick(() => {
      if (window.scrollBar) window.scrollBar.scrollTop = 0

      // setTimeout(() => {
      //   this.loader.hide()
      // }, 300)
    })
  }
}
</script>

<style lang="scss" scoped>
.main, .color-change {
  background: linear-gradient(#cae6f9, #cae6f9, #fff);
}
</style>
